import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {Currency, RightsEnum} from '../../../global';
import { NgIf } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { AccessDirective } from '../../directives/has-access.directive';
import { LoaderComponent } from '../loader/loader.component';
import { CurrencyTransformPipe } from '../../pipes/currency-transform.pipe';

@Component({
    selector: 'slm-payment-overview',
    templateUrl: './payment-overview.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, TranslateDirective, AccessDirective, LoaderComponent, TranslatePipe, CurrencyTransformPipe]
})
export class PaymentOverviewComponent {
  public readonly rights = RightsEnum;
  @Input() balance: any = null;
  @Input() labels: any = null;
  @Input() currency: Currency = null;
}
